import React, { useEffect, useRef, useState } from 'react';
import { ChevronRightIcon, LoaderCircleIcon, LocateFixedIcon, MapPinIcon } from 'lucide-react';
import { addresses } from '../../data/profil';
interface LocationPickerProps {
  onPick: (address: string, source: 'position' | 'profil') => void;
  /** Adresse renvoyee par la geolocalisation simulee. */
  detectedAddress: string;
}
export function LocationPicker({
  onPick,
  detectedAddress
}: LocationPickerProps) {
  const [locating, setLocating] = useState(false);
  const timerRef = useRef<number | null>(null);
  useEffect(() => () => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
  }, []);
  const locate = () => {
    if (locating) return;
    setLocating(true);
    timerRef.current = window.setTimeout(() => {
      setLocating(false);
      onPick(detectedAddress, 'position');
    }, 900);
  };
  return <div className="mt-4 space-y-2" data-id="element-767" data-mp="tpxanyjrz1b7">
      <button type="button" onClick={locate} aria-busy={locating} className="flex w-full items-center gap-3 rounded-2xl bg-ville-navy px-4 py-3 text-left text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-768" data-mp="xoekipukypwb">
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/15" aria-hidden="true" data-id="element-769" data-mp="3xynkuva1mie">
          {locating ? <LoaderCircleIcon className="h-4 w-4 animate-spin" data-id="element-770" data-mp="j5jjppiz1p" /> : <LocateFixedIcon className="h-4 w-4" data-id="element-771" data-mp="3r59ctsg88kw8" />}
        </span>
        <span className="min-w-0 flex-1" data-id="element-772" data-mp="3me112prfcnfw">
          <span className="block text-sm font-bold" data-id="element-773" data-mp="3mc6j9kbg9bg1">
            {locating ? 'Finding your location…' : 'Use my current location'}
          </span>
          <span className="block text-xs text-white/60" data-id="element-774" data-mp="3cfv32j8qo1gb">
            {locating ? 'Looking for the closest point' : 'Fastest if you are on site'}
          </span>
        </span>
      </button>

      <ul className="space-y-2" data-id="element-775" data-mp="33ewvxs307dti">
        {addresses.map(address => <li key={address.id} data-id="element-776" data-mp="33ff1jfbk34e3">
            <button type="button" onClick={() => onPick(address.street, 'profil')} className="group flex w-full items-center gap-3 rounded-2xl border border-slate-200 px-4 py-3 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-777" data-mp="33h9fg9oetw8o">
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ville-mist text-ville-deep" aria-hidden="true" data-id="element-778" data-mp="2oszlei7ug04f">
                <MapPinIcon className="h-4 w-4" data-id="element-779" data-mp="3ck50gv5ymodo" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-780" data-mp="3hgc9wxxkei0d">
                <span className="flex flex-wrap items-center gap-2" data-id="element-781" data-mp="32s8y37wucc3n">
                  <span className="text-sm font-bold text-ville-navy" data-id="element-782" data-mp="32pv6xa5a7k1d">{address.street}</span>
                  {address.primary && <span className="rounded-full bg-ville-lime px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-ville-navy" data-id="element-783" data-mp="3vgmzzyr1vskh">
                      Primary
                    </span>}
                </span>
                <span className="block text-xs text-slate-500" data-id="element-784" data-mp="1oruqswkz16ad">
                  {address.label} · {address.city}
                </span>
              </span>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-slate-300 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-785" data-mp="1jt1eh7hf7lbs" />
            </button>
          </li>)}
      </ul>

      <p className="pt-1 text-xs text-slate-500" data-id="element-786" data-mp="1tlgva1gze3v3">
        Somewhere else in town? Type the address or the intersection in the field below.
      </p>
    </div>;
}